import {useEffect, useState} from "react";
import {Alert, Button, Form, Input, Result, Spin} from "antd";
import {Link, useSearchParams} from "react-router-dom";
import {acceptInvitation, inspectInvitation} from "../../shared/services/administrators";
import styles from "./admin-invitation-page.module.scss";

const AdminInvitationPage = () => {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [invitation, setInvitation] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [complete, setComplete] = useState(false);

    useEffect(() => {
        inspectInvitation(token).then(setInvitation)
            .catch((requestError) => setError(requestError?.response?.data?.message || "This invitation is invalid"))
            .finally(() => setLoading(false));
    }, [token]);

    const submit = async (values) => {
        setSubmitting(true); setError("");
        try { await acceptInvitation({...values, token}); setComplete(true); }
        catch (requestError) { setError(requestError?.response?.data?.message || "Could not accept invitation"); }
        finally { setSubmitting(false); }
    };

    if (loading) return <div className={styles.center}><Spin size="large"/></div>;
    if (complete) return <div className={styles.wrapper}><Result status="success" title="Administrator account created" extra={<Link to="/"><Button type="primary">Sign in to ERP</Button></Link>}/></div>;

    return <div className={styles.wrapper}>
        <div className={styles.panel}>
            <h1>Accept administrator invitation</h1>
            {invitation && <p>Create your <strong>{invitation.role}</strong> account for <span className={styles.email}>{invitation.email}</span>.</p>}
            {error && <Alert className={styles.alert} type="error" showIcon message={error}/>} 
            {invitation && <Form layout="vertical" onFinish={submit}>
                <Form.Item name="firstname" label="First name" rules={[{required:true}]}><Input autoComplete="given-name"/></Form.Item>
                <Form.Item name="lastname" label="Last name" rules={[{required:true}]}><Input autoComplete="family-name"/></Form.Item>
                <Form.Item name="password" label="Password" rules={[{required:true,min:10,message:"Use at least 10 characters"}]}><Input.Password autoComplete="new-password"/></Form.Item>
                <Form.Item name="confirm" label="Confirm password" dependencies={["password"]} rules={[{required:true},({getFieldValue}) => ({validator:(_, value) => !value || getFieldValue("password") === value ? Promise.resolve() : Promise.reject(new Error("Passwords do not match"))})]}><Input.Password autoComplete="new-password"/></Form.Item>
                <Button type="primary" htmlType="submit" loading={submitting} block>Create administrator account</Button>
            </Form>}
            {!invitation && <Link to="/">Return to sign in</Link>}
        </div>
    </div>;
};

export default AdminInvitationPage;
